import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-474eae80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "external-examiner-modal" }
const _hoisted_2 = { class: "heading-text" }
const _hoisted_3 = { class: "line1" }
const _hoisted_4 = { class: "body-main" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Status:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Practice Name:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Address:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "External Examiner LawID:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "External Examiner name:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "External Examiner email:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_13 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Reason for termination:", -1))
const _hoisted_15 = {
  readonly: "",
  style: {"width":"100%","max-height":"100px","resize":"vertical"}
}
const _hoisted_16 = {
  key: 2,
  class: "mb-4"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Reason:", -1))
const _hoisted_18 = {
  readonly: "",
  style: {"width":"100%","max-height":"100px","resize":"vertical"}
}
const _hoisted_19 = { key: 3 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "label" }, "Reason:", -1))
const _hoisted_22 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "fa fa-info-circle mr-2",
    style: {"font-size":"20px","color":"var(--ls-slate)"}
  }),
  /*#__PURE__*/_createElementVNode("div", null, "Trust Coordinators will be notified via email regarding the appointment of this External Examiner for the specified Practice, including the notes.")
], -1))
const _hoisted_26 = { class: "controls" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[3] || (_cache[3] = $event => (_ctx.closeModal()))
    }, _createSlots({
      "header-text": _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.line1Text), 1)
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_LoadingIndicator, {
                key: 0,
                class: "loading-indicator",
                showLoadingText: false
              }))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "btn btn-default ml-1",
            disabled: _ctx.isLoading,
            onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
          }, "Cancel", 8, _hoisted_27),
          (_ctx.actionType !== 3)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-primary ml-2",
                disabled: _ctx.isLoading,
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.submitting()))
              }, _toDisplayString(_ctx.btnText), 9, _hoisted_28))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 2
    }, [
      (_ctx.selectedEE)
        ? {
            name: "body",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                (_ctx.actionType === 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _hoisted_6,
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.selectedEE.eeRequestFormStatus?.id === 3 ? 'error' : 'green' )
                      }, _toDisplayString(_ctx.selectedEE.eeRequestFormStatus?.name), 3)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_7,
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedEE.practice?.practiceName), 1),
                _hoisted_8,
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedEE.practice?.address), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.questionText), 1),
                _hoisted_9,
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedEE.externalExaminer?.lawId), 1),
                _hoisted_10,
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedEE.externalExaminer?.firstName) + " " + _toDisplayString(_ctx.selectedEE.externalExaminer?.lastName), 1),
                _hoisted_11,
                _createElementVNode("div", null, _toDisplayString(_ctx.selectedEE.externalExaminer?.email), 1),
                _hoisted_12,
                (_ctx.formType == 2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _hoisted_14,
                      _createElementVNode("textarea", _hoisted_15, _toDisplayString(_ctx.selectedEE.terminationReason), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.actionType == 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createElementVNode("textarea", _hoisted_18, _toDisplayString(_ctx.selectedEE.note), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.actionType !== 3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _hoisted_20,
                      _hoisted_21,
                      _createElementVNode("div", {
                        class: _normalizeClass(["textarea_box", _ctx.isSubmitting & _ctx.reason === '' ? 'error': ''])
                      }, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.reason) = $event)),
                          maxlength: "5000",
                          placeholder: "Enter reason",
                          style: {"border":"1px solid #aaa","resize":"vertical","width":"100%","height":"200px"}
                        }, null, 512), [
                          [_vModelText, _ctx.reason]
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["footnote", [_ctx.reason?.length >= 5000 ? 'full' : '']])
                        }, _toDisplayString(_ctx.reason?.length || 0) + "/5000 characters ", 3),
                        (_ctx.isSubmitting & _ctx.reason === '')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                              _hoisted_23,
                              _createTextVNode(" Please enter a reason ")
                            ]))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_24,
                _hoisted_25
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024)
  ]))
}